"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getFirstSupportedLanguage = exports.getFirstSupportedLanguage = function getFirstSupportedLanguage(preferredLanguages, supportedLanguages) {
  var language = Array.isArray(preferredLanguages) ? preferredLanguages.find(function (lang) {
    return supportedLanguages.includes(lang);
  }) : preferredLanguages;
  return language ? language : supportedLanguages.length ? supportedLanguages[0] : undefined;
};